import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllShiftPolicies = async ({ companyCode, locationCode, isTrue=true }) => {
  
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAllShiftPolicy}?isAll=true&CompanyCode=${companyCode}&LocationCode=${locationCode}`
  );
  return data;
};

const getShiftPolicyById = async ({ companyCode,locationCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetShiftPolicy}?CompanyCode=${companyCode}&ShiftPolicyID=${code}&LocationCode=${locationCode}`
  );
  return data;
};

const insertShiftPolicy = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.InsertShiftPolicy,
    input
  );
  return data;
};

const updateShiftPolicy = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateShiftPolicy,
    input
  );
  return data;
};

const deleteShiftPolicy = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.DeleteShiftPolicy}?CompanyCode=${companyCode}&ShiftPolicyID=${code}`
  );
  return data;
};

export const useGetAllShiftPoliciesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAllShiftPolicy],
    queryFn: () => getAllShiftPolicies(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetShiftPolicyByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetShiftPolicy],
    queryFn: () => getShiftPolicyById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertShiftPolicyMutation = () => {
  return useMutation({
    mutationFn: insertShiftPolicy,
  });
};

export const useUpdateShiftPolicyMutation = () => {
  return useMutation({
    mutationFn: updateShiftPolicy,
  });
};

export const useDeleteShiftPolicyMutation = () => {
  return useMutation({
    mutationFn: deleteShiftPolicy,
  });
};
